import { get } from "./api"
import { exportResponse } from "./export"

export const exportPriceReportInPeriodOfTime = async (params, fileName) => {
  const response = await get("/price-reports/export-as-xlsx", params, {
    download: true,
  })
  exportResponse(response, fileName)
}
